import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const environmentsRouteRef = createRouteRef();

export const createEnvironmentRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/new',
});

export const environmentRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/:environment',
});

export const editEnvironmentRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/:environment/edit',
});

export const deletedEnvironmentsRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/deleted',
});

export const deletedEnvironmentRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/deleted/:environment',
});

export const configsRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/configs',
});

export const createConfigRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/configs/new',
});

export const configRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/configs/:configName',
});

export const launchConfigRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/configs/:configName/launch',
});

export const editConfigRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/configs/:configName/edit',
});

export const costsOverviewRouteRef = createSubRouteRef({
  parent: environmentsRouteRef,
  path: '/costs-overview',
});

// The `/environments-v3` URL, the page path before PS-1102. It redirects to
// the same sub-path under `/environments`.
export const legacyEnvironmentsRedirectRouteRef = createRouteRef();
